import { render, staticRenderFns } from "./OnboardMember.vue?vue&type=template&id=1302d69b&"
import script from "./OnboardMember.vue?vue&type=script&lang=js&"
export * from "./OnboardMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports